import { requestDeleteRolesManagement } from 'app/api/roles'
import { RoleMessageCode } from 'app/api/roles/constant'
import R from 'app/assets/R'
import { notificationController } from 'app/controllers/notification-controller'
import { isEqual } from 'lodash'
import { ResponseType } from 'parkway-web-common'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IPropsDeleteRole } from './type'

export const useModalHook = (props: IPropsDeleteRole) => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const showModal = () => {
    setVisible(true)
  }

  const handleCancel = () => {
    setVisible(false)
  }

  const handleSubmit = async () => {
    setIsLoading(true)
    try {
      if (!props?.role?._id) return

      const response: ResponseType<string> = await requestDeleteRolesManagement(
        props?.role?._id,
      )

      if (
        isEqual(
          response?.msgcode,
          RoleMessageCode.RoleManagement.successGetData,
        )
      ) {
        setIsLoading(false)
        handleCancel()
        props?.fetchTable?.()
        notificationController.success({
          message: t(R.strings.role_content_delete_role),
          description: response?.message,
        })
      } else {
        notificationController.error({
          message: t(R.strings.role_content_delete_role),
          description: response?.message,
        })
      }

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    visible,
    t,
    isLoading,
    showModal,
    handleSubmit,
    handleCancel,
  }
}
